/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Typography, Form, notification } from "antd";
import { useTranslation } from "react-i18next";
import { getCode } from "country-list";

import PersonalInfo from "./PersonalInfo";
import PassportInfo from "./PassportInfo";
import UploadImage from "./UploadImage";
import TripInfo from "./TripInfo";
// import ContactInfo from "./ContactInfo";x
// import Occupation from "./Occupation";
// import FundingAndInsurance from "./FundingAndInsurance";
import { FormInstance } from "antd/lib";
import {
  ApplicationSummary,
  DefaultProfileTypeModal,
} from "../../../../components";
import visaRequestServices from "../../../../api/services/visaRequestServices";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import Occupation from "./Occupation";
const { Title } = Typography;

type ApplicationFormProps = {
  form: FormInstance<IVisaRequestFormData>;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  passportImage: any;
  setPassportImage: (image: any) => void;
  selfieImage: any;
  setSelfieImage: (image: any) => void;
  passportData: any;
  setPassportData: (response: any) => void;
  faceMatchingData: any;
  setFaceMatchingData: (response: any) => void;
};

// const CustomDescription = ({
//   details
// }: {
//   details: { title: string; content: string };
// }) => (
//   <div>
//     <strong>{details.title}</strong>
//     <p>{details.content}</p>
//   </div>
// );

const ApplicationForm = ({
  form,
  setCurrentStep,
  passportImage,
  setPassportImage,
  selfieImage,
  setSelfieImage,
  passportData,
  setPassportData,
  faceMatchingData,
  setFaceMatchingData,
}: ApplicationFormProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [initTripInfo, setInitTripInfo] = useState<boolean>(false);

  // const [currentFormStep, setCurrentFormStep] = useState(0);
  // const [passportImage, setPassportImage] = useState<any>(null);
  // const [selfieImage, setSelfieImage] = useState<any>(null);

  // Handle select default profile type (for auto-fill form)
  const [selectedEntryPurpose, setSelectedEntryPurpose] = useState<string>("");
  const [selectedProfile, setSelectedProfile] = useState<string>("Tourist");
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [hasPromptedProfileModal, setHasPromptedProfileModal] = useState(false);
  const onProfileModalClose = () => setIsProfileModalOpen(false);

  // For province logic
  const [initProvince, setInitProvince] = useState<string | undefined>(
    undefined
  );
  const [initDistrict, setInitDistrict] = useState<string | undefined>(
    undefined
  );
  const [initWard, setInitWard] = useState<string | undefined>(undefined);

  const getDefaultProfileByPurpose = async () => {
    if (selectedProfile) {
      const response = await visaRequestServices.getProfileByPurpose(
        selectedProfile
      );

      if (response.error) {
        notification.error({
          message: "Error",
          description: "Profile not found! Please fill the form manually.",
        });
        return;
      }

      if (response.data) {
        setDefaultValues(response.data[0], {
          preserveOcrFields: Boolean(passportData),
        });
        setIsProfileModalOpen(false);
      }
    }
  };
  const scrollToFirstError = (errorInfo: {
    errorFields: { name: (string | number)[] }[];
  }) => {
    if (errorInfo.errorFields.length > 0) {
      const firstField = errorInfo.errorFields[0].name[0] as string;
      // console.log(firstField);
      const element = document.querySelector(
        `[id="${firstField}"]`
      ) as HTMLElement;
      // console.log(element);
      if (element) {
        // console.log("scroll");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };
  const stepsData = [
    {
      originalTitle: t("registration_form.in_progress_status"),
      description: {
        title: t("registration_form.progress_bar.step1"),
        content: t("registration_form.progress_bar.step1.description"),
      },
      content: (
        <>
          <UploadImage
            t={t}
            loading={loading}
            setLoading={setLoading}
            error={error}
            setError={setError}
            passportData={passportData}
            setPassportData={setPassportData}
            passportImage={passportImage}
            setPassportImage={setPassportImage}
            setSelfieImage={setSelfieImage}
            selfieImage={selfieImage}
            faceMatchingData={faceMatchingData}
            setFaceMatchingData={setFaceMatchingData}
          />
          <Form form={form} layout="vertical" className="space-y-6">
            <PassportInfo form={form} passportData={passportData} />
          </Form>
        </>
      ),
    },
    {
      originalTitle: t("registration_form.waiting_status"),
      description: {
        title: t("registration_form.progress_bar.step2"),
        content: t("registration_form.progress_bar.step2.description"),
      },
      content: (
        <>
          {/* <div className="w-full py-4 px-8 bg-primary-lightblue rounded-lg text-primary-blue text-base font-semibold">
            {t("registration_form.step2.rule")}
          </div> */}
          <Form form={form} layout="vertical" className="space-y-6">
            <PersonalInfo form={form} passportData={passportData} />
            {/* <ContactInfo /> */}
          </Form>
        </>
      ),
    },
    {
      originalTitle: t("registration_form.waiting_status"),
      description: {
        title: t("registration_form.progress_bar.step6"),
        content: t("registration_form.progress_bar.step6.description"),
      },
      content: (
        <>
          <Form form={form} layout="vertical" className="space-y-6">
            <TripInfo
              form={form}
              setSelectedEntryPurpose={setSelectedEntryPurpose}
              initProvince={initProvince}
              initDistrict={initDistrict}
              initWard={initWard}
              init={initTripInfo}
              setInit={setInitTripInfo}
            />
            {selectedEntryPurpose === "Working" ||
            selectedEntryPurpose === "Business" ? (
              <Occupation />
            ) : null}
          </Form>
          {/* <div className="w-full py-4 px-8 bg-primary-lightblue rounded-lg text-primary-blue text-base font-semibold">
            {t("registration_form.step5.rule")}
            </div> */}
          {/* <Occupation /> */}
          {/* <FundingAndInsurance form={form} /> */}
        </>
      ),
    },
    // {
    //   originalTitle: t("registration_form.waiting_status"),
    //   description: {
    //     title: t("registration_form.progress_bar.step5"),
    //     content: t("registration_form.progress_bar.step5.description")
    //   },
    //   content: (
    //     <>
    //       <Form form={form} layout="vertical" className="space-y-6">
    //         <Occupation />
    //       </Form>
    //     </>
    //   )
    // }
    // {
    //   originalTitle: t("registration_form.waiting_status"),
    //   description: {
    //     title: t("registration_form.progress_bar.step3"),
    //     content: t("registration_form.progress_bar.step3.description")
    //   },
    //   content: (
    //     <>
    //       <div className="w-full py-4 px-8 bg-primary-lightblue rounded-lg text-primary-blue text-base font-semibold">
    //         {t("registration_form.step3.rule")}
    //       </div>
    //       <Form form={form} layout="vertical" className="space-y-6">
    //         <PassportInfo form={form} passportData={passportData} />
    //       </Form>
    //     </>
    //   )
    // },
    // {
    //   originalTitle: t("registration_form.waiting_status"),
    //   description: {
    //     title: t("registration_form.progress_bar.step4"),
    //     content: t("registration_form.progress_bar.step4.description")
    //   },
    //   content: (
    //     <>
    //       <div className="w-full py-4 px-8 bg-primary-lightblue rounded-lg text-primary-blue text-base font-semibold">
    //         {t("registration_form.step4.rule")}
    //       </div>
    //       <Form form={form} layout="vertical" className="space-y-6">
    //         <ContactInfo />
    //       </Form>
    //     </>
    //   )
    // },
    // {
    //   originalTitle: t("registration_form.waiting_status"),
    //   description: {
    //     title: t("registration_form.progress_bar.step6"),
    //     content: t("registration_form.progress_bar.step6.description")
    //   },
    //   content: (
    //     <>
    //       <Form form={form} layout="vertical" className="space-y-8">
    //         <TripInfo form={form} />
    //       </Form>
    //     </>
    //   )
    // },
    // {
    //   originalTitle: t("registration_form.waiting_status"),
    //   description: {
    //     title: t("registration_form.progress_bar.step7"),
    //     content: t("registration_form.progress_bar.step7.description")
    //   },
    //   content: (
    //     <div>
    //       <Form form={form} layout="vertical" className="space-y-6">
    //         <FundingAndInsurance form={form} />
    //       </Form>
    //     </div>
    //   )
    // }
  ];

  const handleNext = () => {
    if (!passportImage || !selfieImage) {
      setError("Please upload your passport and selfie images!");
      scrollToFirstError({
        errorFields: [{ name: ["upload-images"] }],
      });
      return;
    } else setError(null);

    // Step validate
    form
      .validateFields()
      .then(() => {
        setCurrentStep(2);
        setPassportData(null);
        setInitTripInfo(true);
      })
      .catch((errorInfo) => {
        console.error(errorInfo);
        scrollToFirstError(errorInfo);
      });

    // if (currentFormStep < stepsData.length - 1) {
    //   if (currentFormStep === 0) {
    //
    //   }
    //   // setCurrentFormStep((prev) => prev + 1); // Move to the next step
    // } else {
    //   setCurrentStep(2);
    // }
  };

  // Default values for the form after uploading passport image
  const handleGetDefaultValues = async (passportNumber: string) => {
    const response = await visaRequestServices.searchVisaRequestByPassport(
      passportNumber // "A12345678"
    );

    if (response.error) return null;

    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  };

  const hasMeaningfulValue = (value: any) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  };

  const toDayjsOrUndefined = (value: any) => {
    if (!hasMeaningfulValue(value)) return undefined;
    const d = dayjs(value);
    return d.isValid() ? (d as any) : undefined;
  };

  const toNationalityCode = (value: any) => {
    if (!hasMeaningfulValue(value)) return undefined;
    const raw = String(value);
    return getCode(raw) || raw;
  };

  const setDefaultValues = (
    userInfo: any,
    options?: {
      preserveOcrFields?: boolean;
    }
  ) => {
    const preserveOcrFields = Boolean(options?.preserveOcrFields);
    const preferExistingKeys = new Set<string>(
      preserveOcrFields
        ? [
            "surname",
            "middle_and_given_name",
            "date_of_birth",
            "gender",
            "nationality",
            "place_of_birth",
            "id_card",
            "request_passport_number",
            "passport_place_of_issue",
            "passport_type",
            "date_of_issue",
            "passport_expiry_date",
          ]
        : []
    );

    const nextValues: Record<string, any> = {
      // Core personal/passport info (filled from OCR when available; otherwise from profile/previous application)
      surname: userInfo?.surname ?? userInfo?.sur_name,
      middle_and_given_name:
        userInfo?.middle_and_given_name ?? userInfo?.given_name,
      date_of_birth: toDayjsOrUndefined(
        userInfo?.date_of_birth ?? userInfo?.dob
      ),
      gender: userInfo?.gender,
      nationality: toNationalityCode(userInfo?.nationality),
      request_passport_number:
        userInfo?.request_passport_number ??
        userInfo?.passport_number ??
        userInfo?.id,
      date_of_issue: toDayjsOrUndefined(
        userInfo?.date_of_issue ??
          userInfo?.passport_date_of_issue ??
          userInfo?.issue_date
      ),
      passport_expiry_date: toDayjsOrUndefined(
        userInfo?.passport_expiry_date ??
          userInfo?.expiry_date ??
          userInfo?.due_date
      ),

      id_card: userInfo.id_card,
      // email: userInfo.email,
      // confirm_email: userInfo.email,
      religion: userInfo.religion,
      place_of_birth: userInfo.place_of_birth,
      other_passports: userInfo.other_passports
        ? userInfo.other_passports.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            passport_number: item.passport_number,
            fullname: item.fullname,
            date_of_birth: dayjs(item.date_of_birth).format("DD/MM/YYYY"),
            nationality: item.nationality,
          }))
        : [],
      other_valid_passports: userInfo.other_valid_passports
        ? userInfo.other_valid_passports.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            passport_type: item.passport_type,
            passport_specify: item.passport_specify,
            passport_number: item.passport_number,
            passport_place_of_issue: item.passport_place_of_issue,
            passport_date_of_issue: dayjs(item.passport_date_of_issue).format(
              "DD/MM/YYYY"
            ),
            passport_expiry_date: dayjs(item.passport_expiry_date).format(
              "DD/MM/YYYY"
            ),
          }))
        : [],
      other_nationalities: userInfo.other_nationalities
        ? userInfo.other_nationalities.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            country_name: item,
          }))
        : [],
      laws_violation: userInfo.laws_violation
        ? userInfo.laws_violation.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            act_of_violation: item.act_of_violation,
            time_of_violation: dayjs(item.time_of_violation).format(
              "DD/MM/YYYY"
            ),
            form_of_sanction: item.form_of_sanction,
            authority_imposed_sanction: item.authority_imposed_sanction,
          }))
        : [],
      create_account_by_email: userInfo.create_account_by_email,
      passport_place_of_issue: userInfo.passport_place_of_issue,
      passport_type: userInfo.passport_type,
      permanent_residental_address: userInfo.permanent_residental_address,
      contact_address: userInfo.contact_address,
      telephone_number: userInfo.telephone_number,
      emergency_fullname: userInfo.emergency_fullname,
      emergency_current_residental_address:
        userInfo.emergency_current_residental_address,
      emergency_telephone_number: userInfo.emergency_telephone_number,
      emergency_relationship: userInfo.emergency_relationship,
      occupation: userInfo.occupation,
      occupation_info: userInfo.occupation_info,
      company_name: userInfo.company_name,
      position_of_study: userInfo.position_of_study,
      company_address: userInfo.company_address,
      company_phone_number: userInfo.company_phone_number,
      entry_purpose: userInfo.entry_purpose,
      intended_date_of_entry: dayjs(userInfo.intended_date_of_entry),
      intended_length_of_stay: userInfo.intended_length_of_stay,
      vietnam_phone_number: userInfo.vietnam_phone_number,
      vietnam_residental_address: userInfo.vietnam_residental_address,
      // province: userInfo.province,
      // district: userInfo.district,
      // ward: userInfo.ward,
      intended_entry_border_gate: userInfo.intended_entry_border_gate,
      intended_exit_border_gate: userInfo.intended_exit_border_gate,
      committed_declaration: true,
      contact_plans: userInfo.contact_plans
        ? userInfo.contact_plans.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            name: item.name,
            telephone_number: item.telephone_number,
            address: item.address,
            purpose: item.purpose,
          }))
        : [],
      trips_in_the_last_one_year: userInfo.trips_in_the_last_one_year
        ? userInfo.trips_in_the_last_one_year.map(
            (item: any, index: number) => ({
              key: index.toString() + Date.now().toString(),
              from_date: dayjs(item.from_date).format("DD/MM/YYYY"),
              to_date: dayjs(item.to_date).format("DD/MM/YYYY"),
              purpose_of_trip: item.purpose_of_trip,
            })
          )
        : [],
      relatives_in_vietnam: userInfo.relatives_in_vietnam
        ? userInfo.relatives_in_vietnam.map((item: any, index: number) => ({
            key: index.toString() + Date.now().toString(),
            fullname: item.fullname,
            date_of_birth: dayjs(item.date_of_birth).format("DD/MM/YYYY"),
            nationality: item.nationality,
            relationship: item.relationship,
            residental_address: item.residental_address,
          }))
        : [],
      intended_expenses: userInfo.intended_expenses,
      buy_insurance: userInfo.insurance_specify ? true : false,
      insurance_specify: userInfo.insurance_specify,
      trip_expenses_cover_by: userInfo.trip_expenses_cover_by,
      expenses_payment_method: userInfo.expenses_payment_method,
      expenses_company: userInfo.expenses_company,
      expenses_company_address: userInfo.expenses_company_address,
      expenses_company_telephone_number: userInfo.expenses_company_phone_number,
      agree_terms: true,

      // NOTE: if you add more fields here, they will also go through preserve logic below.
    };

    // Preserve OCR-filled (or already-entered) values for selected keys.
    for (const key of Object.keys(nextValues)) {
      if (!preferExistingKeys.has(key)) continue;
      const current = form.getFieldValue(key as any);
      if (hasMeaningfulValue(current)) {
        delete nextValues[key];
      }
    }

    form.setFieldsValue(nextValues);

    // setInitTripInfo(true);
    setSelectedEntryPurpose(userInfo.entry_purpose);
    setInitProvince(userInfo.province);
    setInitDistrict(userInfo.district);
    setInitWard(userInfo.ward);
  };

  useEffect(() => {
    const findDefaultValues = async () => {
      if (passportData) {
        // Lấy giá trị hiện tại của form
        // const currentValues = form.getFieldsValue();
        // console.log("currentValues", currentValues);

        // Chỉ set nếu field chưa có dữ liệu
        form.setFieldsValue({
          surname: passportData.sur_name,
          middle_and_given_name: passportData.given_name,
          date_of_birth: passportData.dob
            ? (dayjs(passportData.dob, "DD/MM/YYYY") as any)
            : undefined,
          gender: passportData.gender,
          nationality: getCode(passportData.nationality || ""),
        });

        const userInfo = await handleGetDefaultValues(passportData.id);

        if (!userInfo) {
          setIsProfileModalOpen(true);
          setHasPromptedProfileModal(true);
        } else {
          notification.success({
            message: "Success",
            description:
              "We found your previous visa application and filled the form for you! Please review the information below and make any necessary changes.",
          });

          setDefaultValues(userInfo, { preserveOcrFields: true });
        }
      }
    };

    findDefaultValues();
  }, [passportData]);

  useEffect(() => {
    // If OCR fails (passportData === null) but user uploaded a passport image,
    // still allow selecting a default profile (best-effort).
    if (hasPromptedProfileModal) return;
    if (passportImage && passportData === null) {
      setIsProfileModalOpen(true);
      setHasPromptedProfileModal(true);
    }
  }, [hasPromptedProfileModal, passportData, passportImage]);

  // const getStepsWithDynamicTitles = () =>
  //   stepsData.map((step, index) => ({
  //     title:
  //       index < currentFormStep
  //         ? t("registration_form.finished_status")
  //         : index === currentFormStep
  //         ? t("registration_form.in_progress_status")
  //         : step.originalTitle,
  //     description: <CustomDescription details={step.description} />
  //   }));

  // const handlePrev = () => {
  //   setCurrentFormStep((prev) => (prev > 0 ? prev - 1 : prev));
  // };

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [currentFormStep]);

  return (
    <div className="w-full grid grid-cols-10 gap-6 items-start">
      {/* Content */}
      <div className="xl:col-span-8 col-span-10 space-y-8">
        {stepsData.map((step, index) => (
          <div key={index} className="flex flex-col gap-6">
            <Title level={2}>{`${index + 1}. ` + step.description.title}</Title>
            {step.content}
          </div>
        ))}
      </div>

      {/* Step Bar */}
      <ApplicationSummary className="xl:col-span-2 col-span-10 xl:sticky xl:top-6" />
      {/* <Steps
        className="lg:col-span-2 col-span-10 h-[300px] lg:h-[400px]"
        direction="vertical"
        current={currentFormStep}
        // onChange={(step) => setCurrentFormStep(step)} // Temporary use only, will be removed in the future
        items={getStepsWithDynamicTitles()}
      /> */}

      {/* Modal */}
      <DefaultProfileTypeModal
        isOpen={isProfileModalOpen}
        onOk={getDefaultProfileByPurpose}
        onClose={onProfileModalClose}
        selectedProfile={selectedProfile}
        setSelectedProfile={setSelectedProfile}
      />

      {/* Buttons */}
      <div className="col-span-10">
        <div className="flex w-full justify-center items-center">
          <div className="max-w-[400px] flex max-sm:flex-col gap-4 mt-8 w-full justify-center items-center">
            <button
              className="flex-1 w-full max-w-[250px] py-4 px-6 border-2 font-bold border-primary-blue rounded-3xl text-primary-blue hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              onClick={() => navigate(-1)}
            >
              {t("registration_form.back")}
            </button>
            <button
              className="flex-1 w-full max-w-[250px] py-4 px-6 border font-bold border-transparent rounded-3xl text-primary-blue bg-primary-lightyellow hover:bg-primary-yellow duration-200"
              onClick={handleNext}
            >
              {t("registration_form.continue")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;
